import React from 'react';
//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from '@careinfo/layout';
import OverViewIcon from '../Icons/OverViewIcon';
import { Outlet } from 'react-router-dom';
import OrderIcon from '../Icons/OrderIcon';
import TicketIcon from '../Icons/TicketIcon';
import InvoiceIcon from '../Icons/InvoiceIcon';
import BranchIcon from '../Icons/BranchIcon';
import DeliveryChargeIcon from '../Icons/DeliveryChargeIcon';
import APIIntergationIcon from '../Icons/APIIntergationIcon';
import PickupRequesticon from '../Icons/PickupRequesticon';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import { responsiveClassName } from '../utils/classNames';
import UsersIcon from '../Icons/UsersIcon';
import RoleIcon from '../Icons/RoleIcon';
import WelcomeIcon from '../Icons/WelcomeIcon';
import { getKey } from '../helpers/sessionKey';
export const shouldShowWelcome = getKey('shouldShowWelcome');
export const navigation: any = [
  {
    name: 'Dashboard',
    href: '/',
    icon: '',
    children: [
      ...(shouldShowWelcome === 'true' || shouldShowWelcome === null
        ? [
            {
              name: 'Welcome',
              href: '/',
              icon: WelcomeIcon,
              activeIcon: WelcomeIcon,
            },
            {
              name: 'Overview',
              href: '/overview',
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]
        : [
            {
              name: 'Overview',
              href: '/',
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]),
    ],
  },
  {
    name: 'Operations',
    href: '/',
    icon: '',
    children: [
      {
        name: 'Consignments',
        href: '/order',
        icon: OrderIcon,
        activeIcon: OrderIcon,
        children: [],
      },
      {
        name: 'Pickup Request',
        href: '/pickup-request',
        icon: PickupRequesticon,
        activeIcon: PickupRequesticon,
        children: [],
      },
      {
        name: 'Ticket',
        href: '/ticket',
        icon: TicketIcon,
        activeIcon: TicketIcon,
        children: [],
      },
    ],
  },

  {
    name: 'Finance',
    href: '/',
    icon: '',
    children: [
      {
        name: 'Invoice',
        href: '/invoice',
        icon: InvoiceIcon,
        activeIcon: InvoiceIcon,
      },
    ],
  },
  {
    name: 'User Management',
    href: '/',
    icon: '',
    children: [
      {
        name: 'Users',
        href: '/users',
        icon: UsersIcon,
        activeIcon: UsersIcon,
      },
      {
        name: 'Roles',
        href: '/roles',
        icon: RoleIcon,
        activeIcon: RoleIcon,
      },
    ],
  },
  {
    name: 'Adminstration',
    href: '/',
    icon: '',
    children: [
      {
        name: 'Branch',
        href: '/branch',
        icon: BranchIcon,
        activeIcon: BranchIcon,
      },
      {
        name: 'Delivery Charge',
        href: '/delivery-charge',
        icon: DeliveryChargeIcon,
        activeIcon: DeliveryChargeIcon,
      },
      {
        name: 'API Integrations',
        href: '/api-integration',
        icon: APIIntergationIcon,
        activeIcon: APIIntergationIcon,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw`h-full p-2 overflow-y-auto`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
